import BookingApi from '../../api/booking_api'
//mutations
import { UPDATE_BOOKING_LIST, TOGGLE_LOADING_ON, TOGGLE_LOADING_OFF } from '../type'

//actions
import { B_UPDATE_BOOKING_LIST } from '../type'


const state = {
    bookingList: [],
    loading: false
}

const mutations = {
    [TOGGLE_LOADING_ON]: (state) => {
        state.loading = true
    },
    [TOGGLE_LOADING_OFF]: (state) => {
        state.loading = false
    },
    [UPDATE_BOOKING_LIST]: (state, { Items: items }) => {
        state.bookingList = items && items.sort((a,b) => new Date(b.created_at) - new Date(a.created_at)) || []
    }
}

const actions = {
    [B_UPDATE_BOOKING_LIST]: async ({ commit }, { params = {} }) => {
        try {
            commit(TOGGLE_LOADING_ON)
            const { data } = await BookingApi.getBookingList(params)
            commit(UPDATE_BOOKING_LIST, data)
            commit(TOGGLE_LOADING_OFF)
        } catch (e) {
            console.error('UPDATE_BOOKING_LIST -> ', e)
        }
    },
}


export default {
    namespaced: true,
    state,
    mutations,
    actions
}